document.addEventListener('DOMContentLoaded', function () {

    const menuLinks = document.querySelectorAll('.menu-root-item > .nav-link');

    menuLinks.forEach(link => {

        link.addEventListener('click', function (e) {

            // Active seulement sur desktop
            if (window.innerWidth <= 1124) return;

            const parentItem = this.parentElement;
            const submenu = this.nextElementSibling;

            // 👉 Si PAS de sous-menu → laisser le lien fonctionner normalement
            if (!submenu || !submenu.classList.contains('sub-menu')) return;

            // 👉 Bloquer le lien UNIQUEMENT si sous-menu
            e.preventDefault();

            const isOpen = submenu.classList.contains('is-open');

            // 🔴 Ferme TOUS les autres sous-menus
            document.querySelectorAll('.menu-root-item .sub-menu.is-open').forEach(menu => {
                menu.classList.remove('is-open');
            });

            // 🔵 Toggle celui-ci seulement
            if (!isOpen) {
                submenu.classList.add('is-open');
            }
        });
    });

    // ✅ Fermeture au clic extérieur
    document.addEventListener('click', function (e) {

        if (window.innerWidth <= 1124) return;

        const isClickInsideMenu = e.target.closest('.menu-root-item');

        if (!isClickInsideMenu) {
            document.querySelectorAll('.menu-root-item .sub-menu.is-open').forEach(menu => {
                menu.classList.remove('is-open');
            });
        }
    });

});